import React from 'react';

import { Button } from 'react-bootstrap';

import { BookingOptionSubType } from '../../../types/Activity';
import AttendeesCount from '../../forms/components/AttendeesCount';
import { isMobileResolution } from '../../../infrastructure/utils/common';
import { FullOrderBookingOption } from '../../../types/Order';

import EditOrderBookingOptions from './EditOrderBookingOptions';

type Props = {
  options: Array<FullOrderBookingOption>;
  removeBookingOption: (option: FullOrderBookingOption) => void;
  onAttendeesNumberChanged: (
    id: string,
    attendeesNumber: number
  ) => void;
};

const OrderBookingOptionsList = (props: Props) => {
  const removeBookingOptionAction = (option: FullOrderBookingOption) => {
    return (
      <Button
        type='submit'
        className='submit'
        bsStyle='danger'
        onClick={() => props.removeBookingOption(option)}
      >
        <i className='fas fa-trash' />
      </Button>
    );
  };
  const attendeesCounter = (option: FullOrderBookingOption) => {
    const {
      lineItemId,
      pricingModel,
      subType,
      attendees = [],
      attendeesMinimum,
      attendeesMaximum,
    } = option;
    if (
      pricingModel !== 'person' &&
      subType === BookingOptionSubType.bookingOption
    )
      return null;

    return (
      <AttendeesCount
        showLabel={isMobileResolution()}
        numOfAttendees={attendees.length}
        attendeesChanged={num => props.onAttendeesNumberChanged(lineItemId, num)}
        min={attendeesMinimum}
        max={attendeesMaximum}
      />
    );
  };

  return (
    <EditOrderBookingOptions
      options={props.options}
      uiElements={{
        action: removeBookingOptionAction,
        attendees: attendeesCounter,
      }}
    />
  );
};

export default OrderBookingOptionsList;
